export default "__VITE_ASSET__Jf1UoMhW__"